export var Puzzle3Difficulty;
(function (Puzzle3Difficulty) {
    Puzzle3Difficulty[Puzzle3Difficulty["Easy"] = 1] = "Easy";
    Puzzle3Difficulty[Puzzle3Difficulty["Medium"] = 2] = "Medium";
    Puzzle3Difficulty[Puzzle3Difficulty["Hard"] = 3] = "Hard";
    Puzzle3Difficulty[Puzzle3Difficulty["Expert"] = 4] = "Expert";
})(Puzzle3Difficulty || (Puzzle3Difficulty = {}));
export const name = '@puzzle3/types';
